import styled from '@emotion/styled'
import { HierarchySelect } from '@components/atoms'

export const StyledHierarchySelectField = styled(HierarchySelect)`
  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.input.placeholder};
    font-size: 16px;
  }
  min-width: 200px;
`

export const FieldLabel = styled.label`
  font-size: 16px;
  color: ${({ theme }) => theme.common.textColor};
  margin-bottom: 10px;
  display: inline-block;
  & > .star {
    color: ${({ theme }) => theme.common.errorText};
  }
`

export const ErrorMessage = styled.span`
  &.input-error {
    color: ${({ theme }) => theme.formMessage.errorTextColor};
  }
`

export const HelperMessage = styled.span`
  &.helper-text {
    font-size: 16px;
    color: ${({ theme }) => theme.formMessage.helperTextColor};
  }
`
